//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const instagramSummaryPrefix = 'instagram-account-summary-';

export const InstagramSummaryTrackingIds = {
  FEED_ENGAGEMENT: `${instagramSummaryPrefix}feed-engagement`,
  MENTIONED_TAGGED_CONTAINER: `${instagramSummaryPrefix}mentioned-tagged-container`,
  MENTIONED_TAGGED_MEDIA: `${instagramSummaryPrefix}mentioned-tagged-media`,
  MENTIONED_TAGGED_VIEW_BUTTON: `${instagramSummaryPrefix}mentioned-tagged-view-button`,
  PDF_REPORT_DOWNLOAD_BUTTON: `${instagramSummaryPrefix}pdf-report-download-button`,
  RECENT_PROMOTIONS: `${instagramSummaryPrefix}recent-promotions`,
  RECENT_PROMOTIONS_LEARN_MORE_LINK: `${instagramSummaryPrefix}recent-promotions-learn-more-link`,
  RECENT_PROMOTIONS_TARGET_LINK: `${instagramSummaryPrefix}recent-promotions-target-link`,
  RECENT_PROMOTIONS_VIEW_RESULTS_BUTTON: `${instagramSummaryPrefix}recent-promotions-view-results-button`,
  REFERRALS_CHART: `${instagramSummaryPrefix}referrals-chart`,
  REFERRALS_CONTAINER: `${instagramSummaryPrefix}referrals-container`,
  REFERRALS_RADIO_GROUP: `${instagramSummaryPrefix}referrals-radio-group`,
  REFERRALS_REVENUE_RADIO: `${instagramSummaryPrefix}referrals-revenue-radio`,
  REFERRALS_TRAFFIC_RADIO: `${instagramSummaryPrefix}referrals-traffic-radio`,
  SUMMARY_CHANNELS_CONTAINER: `${instagramSummaryPrefix}channels-container`,
  SUMMARY_CHANNELS_TABLE: `${instagramSummaryPrefix}channels-table`,
  SUMMARY_HEADER_CONTAINER: `${instagramSummaryPrefix}header-container`,
  SUMMARY_HEADER_WEBSITE_LINK: `${instagramSummaryPrefix}header-website-link`,
  SUMMARY_LEARN_MORE: `${instagramSummaryPrefix}learn-more-link`,
  SUMMARY_TRENDS_CHART: `${instagramSummaryPrefix}trends-chart`,
  SUMMARY_TRENDS_CONTAINER: `${instagramSummaryPrefix}trends-container`,
  SUMMARY_TRENDS_DROPDOWN: `${instagramSummaryPrefix}trends-dropdown`,
} as const;
